(() => {
  angular
    .module('app.components')
    .directive('panelOptions', ['$sce',
      ($sce) => ({
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
          icon: '@',
          caption: '@',
          description: '@',
          info: '@',
          alert: '@',
          dirty: '@',
          actions: '@',
          remove: '&',
        },
        controller: ['$scope', ($scope) => {
          if (!$scope.actions) {
            $scope.actions = [];
          }
        }],
        templateUrl: $sce.trustAsResourceUrl('/assets/js/app/components/panels/panel.options.template.html'),
      })
    ]);
})();
